export default __webpack_public_path__ + "static/media/5-FANTASY-II.8c954e57.png";